import { useTheme } from "../context/ThemeContext";
import { Card, CardContent } from "../components/ui/card";
import { Switch } from "../components/ui/switch";
import { Label } from "../components/ui/label";
import { Moon, Sun, Bell, Globe } from "lucide-react";

export default function SettingsPage() {
  const { theme, toggle } = useTheme();
  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-14">
      <div className="text-xs font-semibold uppercase tracking-widest text-primary">Settings</div>
      <h1 className="mt-1 font-display text-3xl sm:text-4xl">Personalise your experience</h1>

      <div className="mt-8 space-y-4">
        <Card className="glass"><CardContent className="p-5 flex items-center justify-between">
          <div className="flex items-center gap-3">
            {theme === "dark" ? <Moon className="w-5 h-5 text-primary"/> : <Sun className="w-5 h-5 text-primary"/>}
            <div>
              <Label className="text-base">Dark mode</Label>
              <p className="text-xs text-muted-foreground">Toggle between light and dark themes.</p>
            </div>
          </div>
          <Switch checked={theme === "dark"} onCheckedChange={toggle} data-testid="settings-theme"/>
        </CardContent></Card>

        <Card className="glass"><CardContent className="p-5 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Bell className="w-5 h-5 text-primary"/>
            <div>
              <Label className="text-base">Notifications</Label>
              <p className="text-xs text-muted-foreground">Show badges when new leads and low-stock alerts arrive.</p>
            </div>
          </div>
          <Switch defaultChecked data-testid="settings-notifications"/>
        </CardContent></Card>

        <Card className="glass"><CardContent className="p-5 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Globe className="w-5 h-5 text-primary"/>
            <div>
              <Label className="text-base">Currency</Label>
              <p className="text-xs text-muted-foreground">Ghana Cedi (GHS ₵) is used across all demos.</p>
            </div>
          </div>
          <div className="text-sm font-semibold">GHS ₵</div>
        </CardContent></Card>
      </div>
    </div>
  );
}
